import { Injectable } from '@angular/core';
//import { User } from '../../../shared/models/user';
import { ConfigService } from '../config.service';
import { User, UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';


@Injectable({
  providedIn: 'root'
})
export class OidcClientService {

  userManager: UserManager;
  configServiceSubscription: any;

  constructor(
    private configService: ConfigService,
  ) {
    this.configServiceSubscription = this.configService.isConfigServiceLoaded.subscribe(isloaded => {
      if (isloaded && !this.userManager) {
        this.loadOIDCSetting();
      }
    });

  }
  loadOIDCSetting() {
    const settings: UserManagerSettings = {
      authority: `${this.configService.idp_AuthorizationUrl}`,
      client_id: `${this.configService.idp_ClientId}`,
      redirect_uri: `${this.configService.idp_RedirectUrl}`,
      response_type: 'code',
      scope: `${this.configService.idp_Scope}`,
      silent_redirect_uri: `${this.configService.idp_SilentRedirectUri}`,
      post_logout_redirect_uri: `${this.configService.idp_PostlogoutRedirectUri}`,
      includeIdTokenInSilentSignout: true,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      //revokeTokensOnSignout: true,
      revokeTokenTypes: ["access_token"],
      metadata: {
        issuer: `${this.configService.idp_AuthorizationUrl}`,
        authorization_endpoint: `${this.configService.idp_AuthorizationUrl}oidc/authorize`,
        token_endpoint: `${this.configService.idp_AuthorizationUrl}oidc/token`,
        end_session_endpoint: `${this.configService.idp_AuthorizationUrl}oidc/logout`,
        userinfo_endpoint: `${this.configService.idp_AuthorizationUrl}oidc/userinfo`,
        revocation_endpoint: `${this.configService.idp_AuthorizationUrl}oidc/token/revoke`,
      }
    };
    this.userManager = new UserManager(settings);

  }
  public getUser(): Promise<User> {
    return this.userManager.getUser();
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }

  public renewToken(): Promise<User> {
    return this.userManager.signinSilent();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }
  public revokeToken(): Promise<void> {
    return this.userManager.revokeTokens();
  }
  public clearUser(): Promise<void> {
    return this.userManager.removeUser();
  }
}
